import React from "react";
import { WizardMedication, MedicationForm } from "@/types/medication";

interface FormStepProps {
  medication: WizardMedication;
  onChange: (medication: WizardMedication) => void;
}

export const FormStep = ({ medication, onChange }: FormStepProps) => {
  // Ensure form has a valid default value
  const currentForm = medication.form || MedicationForm.Tablet;

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-left">
      <div className="space-y-4">
        <label className="block">
          <span className="text-base font-medium">Form</span>
          <span className="text-sm font-small"> (required)</span>
          <select
            value={currentForm}
            onChange={(e) =>
              onChange({
                ...medication,
                form: e.target.value as MedicationForm,
              })
            }
            className="mt-1 w-full rounded-lg border border-input bg-background px-4 py-3 text-foreground transition-smooth focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20"
            required
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
          >
            <option value={MedicationForm.Tablet}>Tablet</option>
            <option value={MedicationForm.Capsule}>Capsule</option>
            <option value={MedicationForm.Injection}>Injection</option>
            <option value={MedicationForm.Inhaler}>Inhaler</option>
            <option value={MedicationForm.Drops}>Drops</option>
            <option value={MedicationForm.Other}>Other</option>
          </select>
        </label>
      </div>
    </div>
  );
};
